// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorBox{background-color:#f3d8d8;border-radius:4px;color:#cd5b5b;padding:15px 25px;font-size:14px;text-align:center}", ""]);
// Exports
module.exports = exports;
